import { SvgIcon, SvgIconProps } from '@mui/material';
import { ReactElement } from 'react';
import { ReactComponent as Icon } from '../../assets/icons/icon-warning.svg';

export default function Warning(props: SvgIconProps): ReactElement {
  return <SvgIcon component={Icon} {...props} />;
}
